import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { RequisiteRequestType, RequisiteResponseType } from 'app/utils/services/types/requisite.type';

const refreshToken = localStorage.getItem('refreshToken');

const requisiteService = {
  getRequisites: async (data: RequisiteRequestType, path: any): Promise<RequisiteResponseType> => {
    try {
      const result = await httpClient.post<RequisiteResponseType>('/api-web/v1/main/get-bank-details', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = path;
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
  getRequisitePdf: async (data: RequisiteRequestType, path: any): Promise<RequisiteResponseType> => {
    try {
      const result = await httpClient.post<RequisiteResponseType>('/api-web/v1/main/get-bank-details', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = path;
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useRequisiteService = (path: any) => {
  const {
    isLoading: isLoadingRequisite,
    data: dataRequisite,
    mutate: requisiteMutation,
  } = useMutation(['requisites'], (data: RequisiteRequestType) => requisiteService.getRequisites(data, path));

  return { isLoadingRequisite, dataRequisite, requisiteMutation };
};

export const useRequisitePdfService = (path: any) => {
  const {
    isLoading: isLoadingRequisitePdf,
    isSuccess: isSuccessRequisitePdf,
    data: dataRequisitePdf,
    mutate: requisitePdfMutation,
  } = useMutation(['requisitesPdf'], (data: RequisiteRequestType) => requisiteService.getRequisitePdf(data, path));

  return { isLoadingRequisitePdf, isSuccessRequisitePdf, dataRequisitePdf, requisitePdfMutation };
};
